import { render, staticRenderFns } from "./TrendTable.vue?vue&type=template&id=79dc89e6&scoped=true"
import script from "./TrendTable.vue?vue&type=script&lang=js"
export * from "./TrendTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79dc89e6",
  null
  
)

export default component.exports